import React, { useState } from "react"
import ProgressSetup from "./ProgressSetup";
import SetupGuide from "./SetupGuide";
import ModalProducts from "../../../components/Modal/ModalProducts";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdOutlineInventory2 } from "react-icons/md";

const AddProducts = ({ step = 0, totalSteps = 4, nextStep = () => { } }) => {
    const [modalProducts, setModalProducts] = useState(false)
    const title = "Cadastre o que sua empresa vende"
    const description = "Produtos organizados facilitam o registro das oportunidades e tornam seus relatórios comerciais mais confiáveis."
    const btnText = "Cadastrar produtos"
    const btnAltText = "Ignorar por enquanto"

    const openModalProducts = () => {
        setModalProducts(true)
    }

    const closeModalProducts = () => {
        setModalProducts(false)
    }

    const saveProducts = (e, _, products) => {
        e.preventDefault()
        api.post("/products", { products }).then(() => {
            nextStep()
        }).catch(err => toast.error(err?.response?.data?.message))
    }

    return (
        <>
            <ProgressSetup
                step={step}
                totalSteps={totalSteps}
                title={title}
                description={description}
                btnText={btnText}
                btnAltText={btnAltText}
                onClick={openModalProducts}
                onClickAlt={nextStep}
            >
                <SetupGuide
                    icon={<MdOutlineInventory2 />}
                    title="Organize seu catálogo inicial"
                    items={[
                        { title: "Crie a categoria principal", description: "Cadastre o produto, serviço, curso ou solução que será negociado." },
                        { title: "Adicione variações quando necessário", description: "Use subitens para planos, modalidades ou versões do mesmo produto." },
                        { title: "Salve para usar nas vendas", description: "Os itens ficarão disponíveis no lead e nos registros de venda." },
                    ]}
                    note="Se ainda não tiver o catálogo definido, você pode ignorar esta etapa e configurar depois."
                />
            </ProgressSetup>
            {modalProducts &&
                <ModalProducts
                    closeModal={closeModalProducts}
                    isNew={true}
                    onSubmit={saveProducts}
                />
            }
        </>
    )
}

export default AddProducts
